import { UserContextRoleProfileIdDTO } from './user-context-role-profile-id-dto';

export interface UserAccountInformationDTO {
    userId?: number;
    userEmail?: string;
    userFullName?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    secondaryEmail?: string;
    accountStatus?: string;
    accountStatusLabel?: string;
    primaryPhone?: string;
    mobilePhone?: string;
    fax?: string;
    preferredLanguageCd?: string;
    objectId?: string;
    deniedReason?: string;
    country?: string;
    instAcronym?: string;
    idbApps?: string;
    isEmailValidated?: boolean;
    activeProfiles?: string;
    activeProfileIds?: UserContextRoleProfileIdDTO[];
    recertifiedDt?: Date;
    isInternal?: boolean;
    b2cAccountActivationDt?: Date;
    accountActivationDtLabel?: string;
    canSyncB2C?: boolean;
    canViewAccountDetails?: boolean;
    missingAccountActivation?: boolean;
    lastActiveUserRoleContextProfileId?: number;
    canAddRoleSelf?: boolean;
    canAddRoleAsApprover?: boolean;
}
